export enum DynamicFormCategoryType {
    RiskValues = 'RiskValues',
    CoverageValues = 'CoverageValues',
}
